<template>
    <DModal
        :show="show"
        :title="__('tools.partners.uploads.invoicing.modals.confirm.title')"
        :message="__('tools.partners.uploads.invoicing.modals.confirm.message')"
        is-confirm
        @close="$emit('close')"
        @confirm="createInvoices"
    />
</template>

<script setup>
import { ref } from 'vue'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'

defineProps({
    show: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['close', 'started'])

const submitting = ref(false)

const createInvoices = async () => {
    if (submitting.value === true) {
        return
    }

    submitting.value = true

    try {
        const response = await window.axios.post(route('tools.partners.partner-uploads.create-invoices'))

        emit('started', response.data)
    } catch (error) {
        emit('started', {
            success: false,
            message: error.response?.data?.message ?? error.message,
            pid: null
        })
    } finally {
        submitting.value = false
        emit('close')
    }
}
</script>
